import axios from 'axios';

const list = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Countries/`,
    withCredentials: true,
});

const item = (id) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Countries/Details/${ id }`,
    withCredentials: true,
});

const create = (element) => {
    const { flagimage, moodimage, ...json } = element;

    const data = new FormData();
    data.set('data', JSON.stringify(json));
    data.append('flagimage', flagimage);
    data.append('moodimage', moodimage);

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Countries/Create`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const update = (id, element) => {
    const { flagimage, moodimage, ...json } = element;

    const data = new FormData();
    data.set('data', JSON.stringify(json));
    if (typeof flagimage !== 'undefined' && flagimage) {
        data.append('flagimage', flagimage);
    }
    if (typeof moodimage !== 'undefined' && moodimage) {
        data.append('moodimage', moodimage);
    }

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Countries/Update/${ id }`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const remove = (id) => axios({
    method: 'delete',
    url: `${ process.env.VUE_APP_API_URL }/Countries/Delete/${ id }`,
    withCredentials: true,
});

export default {
    list,
    item,
    create,
    update,
    remove,
};
